import { Box } from "@design-system/Box/Box";
import { OptionComponentProps } from "@design-system/Select/Select";
import { Text } from "@design-system/Text/Text";

type Props = OptionComponentProps;

export const Option = ({ label }: Props) => {
  return (
    <Box gap={8} align="center">
      <Text>{label}</Text>
    </Box>
  );
};
